import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { SubmittingEntityListModel } from '../models/SubmittingEntityListModel';
import { SubmittingEntityModel } from '../models/SubmittingEntityModel';
import { AddSubmittingEntityModel } from '../models/AddSubmittingEntityModel';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModelResponse } from '../../core/services/ModelResponse';
import {PhysicalAddressModel} from '../../common/models/PhysicalAddressModel';
import { ContactModel } from '../models/ContactModel';
import { AddMappingModel } from '../models/AddMappingModel';
import { DeleteSubmittingEntityModel } from '../models/DeleteSubmittingEntityModel';
import { SubmittingEntityIdentifierModel } from '../models/SubmittingEntityIdentifierModel';

@Injectable()
export class SubmittingEntityService {
  constructor(public httpClient: HttpClient) {
    
  }

  getSubmittingEntityList(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<SubmittingEntityListModel>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<SubmittingEntityListModel>>("/api/SubmissionModule/SubmittingEntity/ListQuery", { params: params });
  }

  getSubmittingEntity(key: string): Observable<ModelResponse<SubmittingEntityModel>> {
    return this.httpClient.get<ModelResponse<SubmittingEntityModel>>("/api/SubmissionModule/SubmittingEntity/Get/" + key);
  }

  addSubmittingEntity(addModel: AddSubmittingEntityModel): Observable<ModelResponse<string>> {
    return this.httpClient.put<ModelResponse<string>>("/api/SubmissionModule/SubmittingEntity/Add/", addModel);
  }

  addMapping(key: string, addModel: AddMappingModel): Observable<ModelResponse<string>> {
    return this.httpClient.put<ModelResponse<string>>("/api/SubmissionModule/SubmittingEntity/" + key + "/Mapping", addModel);
  }

  addAddress(key: string, model: PhysicalAddressModel): Observable<ModelResponse<PhysicalAddressModel>> {
    return this.httpClient.put<ModelResponse<PhysicalAddressModel>>(`/api/SubmissionModule/SubmittingEntity/${key}/Address/`, model);
  }

  reviseAddress(key: string, model: PhysicalAddressModel): Observable<ModelResponse<PhysicalAddressModel>> {
    return this.httpClient.post<ModelResponse<PhysicalAddressModel>>(`/api/SubmissionModule/SubmittingEntity/${key}/Address/${model.key}`, model);
  }

  removeAddress(key: string, addressKey: string): Observable<ModelResponse<PhysicalAddressModel>> {
    return this.httpClient.delete<ModelResponse<PhysicalAddressModel>>(`/api/SubmissionModule/SubmittingEntity/${key}/Address/${addressKey}`);
  }

  addContact(key: string, model: ContactModel): Observable<ModelResponse<ContactModel>> {
    return this.httpClient.put<ModelResponse<ContactModel>>(`/api/SubmissionModule/SubmittingEntity/${key}/Contact/`, model);
  }

  reviseContact(key: string, model: ContactModel): Observable<ModelResponse<ContactModel>> {
    return this.httpClient.post<ModelResponse<ContactModel>>(`/api/SubmissionModule/SubmittingEntity/${key}/Contact/${model.key}`, model);
  }

  removeContact(key: string, contactKey: string): Observable<ModelResponse<ContactModel>> {
    return this.httpClient.delete<ModelResponse<ContactModel>>(`/api/SubmissionModule/SubmittingEntity/${key}/Contact/${contactKey}`);
  }

  reviseName(key: string, name: string): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/SubmissionModule/SubmittingEntity/${key}/ReviseName`, { model: name });
  }

  addIdentifier(key: string, model: SubmittingEntityIdentifierModel): Observable<ModelResponse<SubmittingEntityIdentifierModel>> {
    return this.httpClient.put<ModelResponse<SubmittingEntityIdentifierModel>>(`/api/SubmissionModule/SubmittingEntity/${key}/Identifier/`, model);
  }

  reviseIdentifier(key: string, model: SubmittingEntityIdentifierModel): Observable<ModelResponse<SubmittingEntityIdentifierModel>> {
    return this.httpClient.post<ModelResponse<SubmittingEntityIdentifierModel>>(`/api/SubmissionModule/SubmittingEntity/${key}/Identifier/${model.key}`, model);
  }

  reviseAllowedDataSets(key: string, dataSets: string[]): Observable<ModelResponse<string[]>> {
    return this.httpClient.post<ModelResponse<string[]>>(`/api/SubmissionModule/SubmittingEntity/${key}/ReviseAllowedDataSet`, { model: dataSets });
  }

  reviseAutoGenerateSftpXmlJobReports(key: string, autoGenerateSftpXmlJobReports: boolean): Observable<ModelResponse<boolean>> {
    return this.httpClient.post<ModelResponse<boolean>>(`/api/SubmissionModule/SubmittingEntity/${key}/ReviseAutoGenerateSftpXmlJobReports`, { model: autoGenerateSftpXmlJobReports });
  }

  configureReporting(key: string): Observable<ModelResponse<boolean>> {
    return this.httpClient.post<ModelResponse<boolean>>(`/api/SubmissionModule/SubmittingEntity/${key}/ConfigureReporting`, {});
  }

  deleteSubmittingEntity(deleteModel: DeleteSubmittingEntityModel): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>("/api/SubmissionModule/SubmittingEntity/Delete/", deleteModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/submission/services/SubmittingEntityService.ts